import PushSettingsForm from "@/components/PushSettingsForm";
import PairedDevicesCard from "@/components/PairedDevicesCard";
import { PageHeader } from "@/components/Ui";

export default function TenantPushSettings() {
    return (
        <div className="space-y-6" data-testid="tenant-push-page">
            <PageHeader title="Mobile push notifications"
                subtitle="Configure how your firm receives hearing reminders and cause-list pushes on the mobile app."/>
            <PairedDevicesCard />
            <PushSettingsForm
                scope="tenant"
                headline="Firm preferences"
                getEndpoint="/tenant/push/settings"
                putEndpoint="/tenant/push/settings"
                testEndpoint="/tenant/push/test"
                logsEndpoint="/tenant/push/logs?limit=50"
            />
        </div>
    );
}
